import { useFlag } from '@flash-tecnologia/feature-flags';

const withFeatureFlagEnabled =
  <P extends object>(
    WrappedComponent: React.ComponentType<P>,
    featureFlag: string,
  ) =>
  ({ ...props }) => {
    const isFeatureFlagEnabled = useFlag({
      flagName: featureFlag,
    });
    return isFeatureFlagEnabled ? (
      <WrappedComponent {...(props as P)} />
    ) : (
      false
    );
  };

export { withFeatureFlagEnabled };
